"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOrderReadyToBePaidFor = exports.isValidDeliveryLocation = exports.isCustomerOrderingForNowWhenTheStoreIsClosed = exports.isPaymentMethodValid = exports.setOrderAwaitingPayment = exports.trimDeliveryLocationPostcode = exports.setOrderId = exports.checkOrderIsValid = exports.setHumanId = exports.createOrderStatus = exports.STATES = exports.STATUSES = void 0;
const postcode_validator_1 = require("postcode-validator");
const redash_1 = require("@cnd/redash");
const lodash_1 = require("lodash");
const date_fns_1 = require("date-fns");
exports.STATUSES = [
    { status: 'confirmed', nextStatus: 'preparing', label: 'Preparing' },
    { status: 'preparing', nextStatus: 'ready_for_collection', label: 'Ready for Collection' },
    { status: 'ready_for_collection', nextStatus: 'out_for_delivery', label: 'Out for Delivery' },
    { status: 'out_for_delivery', nextStatus: 'delivered', label: 'Delivered' },
    { status: 'delivered', nextStatus: '', label: '' },
];
exports.STATES = [
    { state: 'CONFIRMED', nextState: 'PREPARING', label: 'Preparing' },
    { state: 'PREPARING', nextState: 'READY_FOR_COLLECTION', label: 'Ready for Collection' },
    { state: 'READY_FOR_COLLECTION', nextState: 'OUT_FOR_DELIVERY', label: 'Out for Delivery' },
    { state: 'OUT_FOR_DELIVERY', nextState: 'DELIVERED', label: 'Delivered' },
    { state: 'DELIVERED', nextState: '', label: '' },
];
const createOrderStatus = (status) => ({
    id: (0, redash_1.uuid)(),
    status,
    changedAt: (0, date_fns_1.formatISO)(new Date()),
});
exports.createOrderStatus = createOrderStatus;
const setHumanId = (order) => (0, redash_1.mergeClone)(order, { humanId: (0, redash_1.cleanReadableId)() });
exports.setHumanId = setHumanId;
const checkOrderIsValid = (order) => {
    let errors = [];
    if (!order.userId)
        errors.push((0, redash_1.createError)("Please start your order again, we're sorry but there has been a problem"));
    if (!order.customerPhoneNumber)
        errors.push((0, redash_1.createError)('Please enter email or phone number'));
    if (!order.stripeCustomerId)
        errors.push((0, redash_1.createError)("Please start your order again, we're sorry but there has been a problem"));
    if (!order.deliveryLocation && !order.collectionLocation) {
        errors.push((0, redash_1.createError)("Please start your order again, we don't know where to send your order"));
    }
    if (order.deliveryLocation) {
        const { postcode, city, streetAddress1 } = order.deliveryLocation;
        if (!postcode)
            errors.push((0, redash_1.createError)('Please enter your postcode'));
        if (!city)
            errors.push((0, redash_1.createError)('Please enter your city'));
        if (!streetAddress1)
            errors.push((0, redash_1.createError)('Please enter your street address'));
        if (!(0, postcode_validator_1.postcodeValidator)((0, redash_1.removeWhiteSpace)(postcode), 'UK'))
            errors.push((0, redash_1.createError)('Please enter a valid delivery postcode.'));
    }
    if (order.collectionLocation && !(0, exports.isValidDeliveryLocation)(order.collectionLocation))
        errors.push((0, redash_1.createError)('Please reselect your store for collection'));
    if (!order.items || !(0, lodash_1.keys)(order.items).length)
        errors.push((0, redash_1.createError)('Please add some items to your order'));
    return {
        valid: errors.length === 0 ? true : false,
        errors,
    };
};
exports.checkOrderIsValid = checkOrderIsValid;
const setOrderId = (order) => (0, redash_1.mergeClone)(order, { id: (0, redash_1.uuid)() });
exports.setOrderId = setOrderId;
const trimDeliveryLocationPostcode = (order) => {
    var _a;
    const postcode = (_a = order.deliveryLocation) === null || _a === void 0 ? void 0 : _a.postcode;
    return (0, redash_1.mergeClone)(order, postcode ? { deliveryLocation: { postcode: postcode.trim() } } : {});
};
exports.trimDeliveryLocationPostcode = trimDeliveryLocationPostcode;
//const DELIVERY_TIME_TOLERENCE_MINS = 5
// export const setupOrderDeliveryTimes = async (order) => {
//   if (!order.isPreOrder) {
//     const deliveryTimesForNow = await getDeliveryTimesForNow()
//     if (
//       Math.abs(
//         deliveryTimesForNow.proposedMinutesUntilDeliveryLower - order.proposedMinutesUntilDeliveryLower
//       ) > DELIVERY_TIME_TOLERENCE_MINS
//     ) {
//       throw createError(
//         `We're very busy, delivery time for your order has increased to ${deliveryTimesForNow.proposedMinutesUntilDeliveryLower} minutes. Is this ok?`,
//         'delivery_time_increased'
//       )
//     }
//     const now = new Date().valueOf()
//     const MS_IN_MIN = 60 * 1000
//     const expectedDeliveryTime = now + deliveryTimesForNow.proposedMinutesUntilDeliveryLower * MS_IN_MIN
//     const expectedDeliveryTimeLimit = now + deliveryTimesForNow.proposedMinutesUntilDeliveryUpper * MS_IN_MIN
//     return {
//       ...order,
//       expectedDeliveryTime,
//       expectedDeliveryTimeLimit,
//     }
//   }
//   if (order.isPreOrder) {
//     const isPreOrderTimeAvailable = await checkDeliveryTimeForLater()
//     if (!isPreOrderTimeAvailable)
//       throw createError(`Your delivery time has been overbooked. Please change your time.`, 'delivery_slot_taken')
//     const expectedDeliveryTime = order.proposedDeliveryTimeLower
//     const expectedDeliveryTimeLimit = order.proposedDeliveryTimeUpper
//     return {
//       ...order,
//       expectedDeliveryTime,
//       expectedDeliveryTimeLimit,
//     }
//   }
//   throw {
//     error: {
//       message: 'isPreOrder unset',
//     },
//   }
// }
const setOrderAwaitingPayment = ({ order }) => (0, redash_1.mergeClone)(order, {
    orderSavedAtTime: new Date().valueOf(),
    status: 'awaiting_payment',
});
exports.setOrderAwaitingPayment = setOrderAwaitingPayment;
const isPaymentMethodValid = ({ customerBankCards, useDifferentCard }) => {
    let errorMessage = '';
    let result = null;
    if (!customerBankCards[0])
        result = true;
    if (customerBankCards[0] && useDifferentCard)
        result = true;
    if (customerBankCards[0] && !useDifferentCard)
        result = true;
    if (!customerBankCards[0]) {
        result = false;
        errorMessage = 'Please enter your card details';
    }
    if (customerBankCards[0] && useDifferentCard) {
        result = false;
        errorMessage = 'Please enter your card details or select existing card';
    }
    if (result === null)
        throw (0, redash_1.createError)(`isPaymentMethodValid threw a null condition for  ${JSON.stringify({ customerBankCards, useDifferentCard }, null, 2)}`);
    if (errorMessage) {
        return {
            error: (0, redash_1.createError)(errorMessage),
            result,
        };
    }
    return {
        result,
    };
};
exports.isPaymentMethodValid = isPaymentMethodValid;
const isCustomerOrderingForNowWhenTheStoreIsClosed = ({ isShopOpen, order }) => {
    let errorMessage = '';
    if (isShopOpen === null)
        errorMessage = 'Sorry, please refresh the page and try again';
    if (isShopOpen === false && !order.isPreOrder)
        errorMessage =
            "We're sorry but we're closed, you can go back and book a delivery for a time when we are open.";
    if (errorMessage)
        return {
            result: false,
            error: (0, redash_1.createError)(errorMessage),
        };
    return {
        result: false,
    };
};
exports.isCustomerOrderingForNowWhenTheStoreIsClosed = isCustomerOrderingForNowWhenTheStoreIsClosed;
const isValidDeliveryLocation = (deliveryLocation) => !!deliveryLocation &&
    !!deliveryLocation.city &&
    !!deliveryLocation.postcode &&
    !!deliveryLocation.streetAddress1;
exports.isValidDeliveryLocation = isValidDeliveryLocation;
const isOrderReadyToBePaidFor = (order) => {
    var _a, _b, _c;
    let errorMessage = '';
    if (!order.userId) {
        errorMessage = 'please start your order again';
    }
    if (!order.customerPhoneNumber)
        errorMessage = 'Please provide your phone number, in case the driver gets lost';
    if (!order.deliveryLocation)
        errorMessage = 'Please tell us where to deliver your order';
    if (!((_a = order === null || order === void 0 ? void 0 : order.deliveryLocation) === null || _a === void 0 ? void 0 : _a.latLng))
        errorMessage = 'Please tell us where to deliver your order';
    if (!order.items || !Object.keys(order.items).length)
        errorMessage = 'Please add some items to your order';
    if (((_b = order.deliveryLocation) === null || _b === void 0 ? void 0 : _b.type) === 'address') {
        const { postcode, city, streetAddress1 } = order.deliveryLocation;
        if (!postcode)
            errorMessage = 'Please enter your postcode';
        if (!city)
            errorMessage = 'Please enter your city';
        if (!streetAddress1)
            errorMessage = 'Please enter your street address';
        if (!(0, postcode_validator_1.postcodeValidator)((0, redash_1.removeWhiteSpace)(postcode), 'UK'))
            errorMessage = 'Please enter a valid delivery postcode';
    }
    else if (((_c = order.deliveryLocation) === null || _c === void 0 ? void 0 : _c.type) === 'droppoint') {
        if (!order.deliveryLocation.latLng.lat || !order.deliveryLocation.latLng.lng)
            errorMessage = 'Please relect your drop point';
    }
    else {
        errorMessage = 'Please select a delivery location';
    }
    if (errorMessage) {
        return {
            ready: false,
            error: (0, redash_1.createError)(errorMessage),
        };
    }
    return {
        ready: true,
    };
};
exports.isOrderReadyToBePaidFor = isOrderReadyToBePaidFor;
//# sourceMappingURL=payment.js.map